module.exports = __webpack_public_path__ + "static/media/North_Station_Line.2982b303.svg";